import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Nav } from "./Nav";
import { Footer } from "./Footer";
import { StickyActions } from "./StickyActions";
import { AIConcierge } from "./AIConcierge";
import { Toaster } from "sonner";

export const Layout = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);

  const isAdmin = pathname.startsWith("/admin");

  return (
    <div className="bg-kc text-ink min-h-screen">
      {!isAdmin && <Nav />}
      <main data-testid="page-main">
        <Outlet />
      </main>
      {!isAdmin && <Footer />}
      {!isAdmin && <StickyActions />}
      {!isAdmin && <AIConcierge />}
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
};
